// Dynamic reports (docs/capsules/dynamic-report.md): what the report modal and Settings need before
// the Dynamic view loads — the per-browser setting's key and when the Standard | Dynamic switch is
// offered. Kept apart from ./dynamicReport.js so the eager modal pulls in only these, and the
// view's polling, stages and failure words load with the view's own chunk.

/** Settings → Debug → "Dynamic reports", per browser. */
export const DYNAMIC_REPORT_PREF_KEY = "sooth-dynamicReport";

/**
 * Whether the report modal offers the Standard | Dynamic switch: the viewer's toggle is on (it
 * already folds in the debug UI and the server's flag), the report shown is the main forecast's
 * live report, and it has a stored report row for the generator to read.
 *
 * @param {{enabled: boolean, rowKey: string|null|undefined, mainReport: boolean,
 *   scrubbed: boolean, reportShown: boolean}} args `mainReport`: the report is the main
 *   forecast's (not a branch or a comparison root), which is what `rowKey` names; `scrubbed`:
 *   the header is not at the live position (a past version, one loading, or the resolution).
 */
export function dynamicReportOffered({ enabled, rowKey, mainReport, scrubbed, reportShown }) {
  return !!(
    enabled &&
    typeof rowKey === "string" &&
    rowKey &&
    mainReport &&
    reportShown &&
    !scrubbed
  );
}
